var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import GlobalConfigActionConstants from "./GlobalConfigActionsConstants.js";
const getDefaultState = () => {
  return {
    controlTowerExperienceConfig: { data: null, error: null, isLoading: false }
  };
};
const GlobalConfigReducer = (state = getDefaultState(), actionResult) => {
  switch (actionResult.type) {
    case GlobalConfigActionConstants.LOADING_CONTROL_TOWER_EXPERIENCE:
      return __spreadProps(__spreadValues({}, state), {
        controlTowerExperienceConfig: { data: null, error: null, isLoading: true }
      });
    case GlobalConfigActionConstants.LOADED_CONTROL_TOWER_EXPERIENCE:
      return __spreadProps(__spreadValues({}, state), {
        controlTowerExperienceConfig: { data: actionResult.payload, error: null, isLoading: false }
      });
    default:
      return state;
  }
};
export {
  GlobalConfigReducer,
  GlobalConfigReducer as default,
  getDefaultState
};
//# sourceMappingURL=GlobalConfigReducer.js.map
